var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":true,"max-width":"500px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }